export const defaultConfig = [
	{
		name: 'age',
	},
	{
		name: 'goal',
	},
	{
		name: 'focus',
	},
	{
		name: 'physicall_active',
	},
	{
		name: 'exercises_time',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'emotional_eating',
	},
	{
		name: 'post_covid',
	},
	{
		name: 'noise_free',
	},
	{
		name: 'kids',
	},
	{
		name: 'medications',
	},
	{
		name: 'diseases',
	},
	{
		name: 'health_issues',
	},
	{
		name: 'body_type',
	},
	{
		name: 'zones',
	},
	{
		name: 'fat',
		gender: 'male',
	},
	{
		name: 'current_level',
	},
	{
		name: 'devices',
	},
	{
		name: 'motivates_exercise',
	},
	{
		name: 'motivation',
	},
	{
		name: 'frequency',
	},
	{
		name: 'duration',
	},
	{
		name: 'habbits',
		gender: 'female',
	},
	{
		name: 'activities_preferences',
	},
	{
		name: 'workouts_preferences',
	},
	{
		name: 'sleep',
	},
	{
		name: 'water',
	},
	{
		name: 'caffeine',
	},
	{
		name: 'previous_fails',
	},
	{
		name: 'motivation_rate',
	},
	{
		name: 'quit_exercising',
	},
	{
		name: 'life_changes',
	},
	{
		name: 'successfully_lost_weight',
	},
	{
		name: 'last_time_ideal_weight',
	},
	{
		name: 'map',
	},
	{
		name: 'nutrition_approaches',
	},
	{
		name: 'medicine_experts',
	},
	{
		name: 'trainers',
	},
	{
		name: 'mail',
	},
];

export const xmas_long = [
	{
		name: 'age',
	},
	{
		name: 'goal',
	},
	{
		name: 'focus',
	},
	{
		name: 'physicall_active',
	},
	{
		name: 'exercises_time',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'emotional_eating',
	},
	{
		name: 'post_covid',
	},
	{
		name: 'noise_free',
	},
	{
		name: 'kids',
	},
	{
		name: 'medications',
	},
	{
		name: 'diseases',
	},
	{
		name: 'health_issues',
	},
	{
		name: 'body_type',
	},
	{
		name: 'zones',
	},
	{
		name: 'fat',
		gender: 'male',
	},
	{
		name: 'current_level',
	},
	{
		name: 'devices',
	},
	{
		name: 'motivates_exercise',
	},
	{
		name: 'motivation',
	},
	{
		name: 'frequency',
	},
	{
		name: 'duration',
	},
	{
		name: 'habbits',
		gender: 'female',
	},
	{
		name: 'activities_preferences',
	},
	{
		name: 'workouts_preferences',
	},
	{
		name: 'sleep',
	},
	{
		name: 'water',
	},
	{
		name: 'caffeine',
	},
	{
		name: 'previous_fails',
	},
	{
		name: 'motivation_rate',
	},
	{
		name: 'quit_exercising',
	},
	{
		name: 'life_changes',
	},
	{
		name: 'successfully_lost_weight',
	},
	{
		name: 'last_time_ideal_weight',
	},
	{
		name: 'map',
	},
	{
		name: 'nutrition_approaches',
	},
	{
		name: 'medicine_experts',
	},
	{
		name: 'trainers',
	},
	{
		name: 'mail',
	},
];

export const xmas_short = [
	{
		name: 'age',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'body_type',
	},
	{
		name: 'current_level',
	},
	{
		name: 'motivation_rate',
	},
	{
		name: 'life_changes',
	},
	{
		name: 'mail',
	},
];

export const AdQ = [
	{
		name: 'age',
	},
	{
		name: 'goal',
	},
	{
		name: 'focus',
	},
	{
		name: 'physicall_active',
	},
	{
		name: 'exercises_time',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'emotional_eating',
	},
	{
		name: 'medications',
	},
	{
		name: 'diseases',
	},
	{
		name: 'health_issues',
	},
	{
		name: 'body_type',
	},
	{
		name: 'zones',
	},
	{
		name: 'fat',
		gender: 'male',
	},
	{
		name: 'current_level',
	},
	{
		name: 'devices',
	},
	{
		name: 'motivates_exercise',
	},
	{
		name: 'motivation',
	},
	{
		name: 'frequency',
	},
	{
		name: 'duration',
	},
	{
		name: 'habbits',
		gender: 'female',
	},
	{
		name: 'activities_preferences',
	},
	{
		name: 'workouts_preferences',
	},
	{
		name: 'sleep',
	},
	{
		name: 'water',
	},
	{
		name: 'caffeine',
	},
	{
		name: 'previous_fails',
	},
	{
		name: 'motivation_rate',
	},
	{
		name: 'quit_exercising',
	},
	{
		name: 'life_changes',
	},
	{
		name: 'successfully_lost_weight',
	},
	{
		name: 'last_time_ideal_weight',
	},
	{
		name: 'map',
	},
	{
		name: 'nutrition_approaches',
	},
	{
		name: 'medicine_experts',
	},
	{
		name: 'trainers',
	},
	{
		name: 'mail',
	},
];

export const short = [
	{
		name: 'age',
	},
	{
		name: 'goal',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'medications',
	},
	{
		name: 'health_issues',
	},
	{
		name: 'zones',
	},
	{
		name: 'devices',
	},
	{
		name: 'motivates_exercise',
	},
	{
		name: 'frequency',
	},
	{
		name: 'duration',
	},
	{
		name: 'mail',
	},
];

export const shortB = [
	{
		name: 'age',
	},
	{
		name: 'goalB',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'medications',
	},
	{
		name: 'health_issues',
	},
	{
		name: 'zones',
	},
	{
		name: 'devices',
	},
	{
		name: 'motivates_exercise',
	},
	{
		name: 'frequency',
	},
	{
		name: 'duration',
	},
	{
		name: 'mail',
	},
];

export const typeV1 = [
	{
		name: 'target_weight',
	},
	{
		name: 'goal',
	},
	{
		name: 'weight',
	},
	{
		name: 'previous_fails',
	},
	{
		name: 'height',
	},
	{
		name: 'health_issues',
	},
	{
		name: 'motivates_exercise',
	},
	{
		name: 'life_changes',
	},
	{
		name: 'nutrition_approaches',
	},
	{
		name: 'mail',
	},
];

export const typeV2 = [
	{
		name: 'goal_three',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'medications',
	},
	{
		name: 'health_issues',
	},
	{
		name: 'previous_fails',
	},
	{
		name: 'mail',
	}
];

export const test = [
	{
		name: 'age',
	},
	{
		name: 'goal',
	},
	{
		name: 'exercises_time',
	},
	{
		name: 'height',
	},
	{
		name: 'weight',
	},
	{
		name: 'target_weight',
	},
	{
		name: 'diet_type',
	},
	{
		name: 'body_type',
	},
	{
		name: 'zones',
	},
	{
		name: 'frequency',
	},
	{
		name: 'duration',
	},
	{
		name: 'mail',
	},
];

export const stepsDetails = {
	goal: {
		showActionBar: true,
	},
	goalB: {
		showActionBar: false,
	},
	goal_three: {
		showActionBar: true,
	},
	zones: {
		showActionBar: true,
	},
	motivation: {
		showActionBar: true,
	},
	nutrition_approaches: {
		showActionBar: true,
	},
	medications: {
		showActionBar: true,
	},
	diseases: {
		showActionBar: true,
	},
	weight: {
		showActionBar: true,
	},
	target_weight: {
		showActionBar: true,
	},
	height: {
		showActionBar: true,
	},
	mail: {
		showActionBar: true,
	},
	body_mass: {
		showActionBar: true,
	},
	caffeine: {
		showActionBar: true,
	},
	quit_exercising: {
		showActionBar: true,
	},
	map: {
		showActionBar: true,
	},
	fat: {
		showActionBar: true,
	},
	before_after: {
		showActionBar: true,
	},
	nutrition_experts: {
		showActionBar: true,
	},
	health_issues: {
		showActionBar: true,
	},
	devices: {
		showActionBar: true,
	},
	previous_fails: {
		showActionBar: true,
	},
	diet_type: {
		showActionBar: true,
	},
	motivates_exercise: {
		showActionBar: true,
	},
	focus: {
		showActionBar: true,
	},
	habbits: {
		showActionBar: true,
	},
	trainers: {
		showActionBar: true,
	},
	medicine_experts: {
		showActionBar: true,
	},
	activities_preferences: {
		showActionBar: true,
	},
	xmas_start_screen: {
		showStatusBar: false,
	},
	big_photo_start_screen: {
		showStatusBar: false,
	},
	age_group_start_screen: {
		showStatusBar: false,
	},
	colored_options_start_screen: {
		showActionBar: true,
	},
	zones_start_screen: {
		showStatusBar: false,
		showActionBar: true,
	},
	new_year_start_screen: {
		showStatusBar: false,
	},
};
